export default {"src":"/_next/static/media/accordion-up.2e7bb893.svg","height":19,"width":18,"blurWidth":0,"blurHeight":0};